import moment from 'moment';
import {
  ConsolidatedContact,
  ContactStatusOptionsObject,
} from '../CoachingNotes/schema';
import { getWeekAndYear } from '../../Util';
import {
  ContactStatus,
  HMDDetails,
  RealTimeHMDContactForReview,
} from '../../PerformancePortal/Dashboard/DashboardComponents/HmdDetails/types';
import { ExtendedUser, User } from '../../Types';
import { UserInput } from '../Training';

export enum ChannelCode {
  PHONE = 'P',
  EMAIL = 'E',
  MESSAGE_US = 'MU',
  CHAT = 'C',
}

export const mapChannelCode = (channelCode: string): string => {
  switch (channelCode?.toUpperCase()) {
    case ChannelCode.PHONE:
      return 'Phone';
    case ChannelCode.EMAIL:
      return 'Email';
    case ChannelCode.MESSAGE_US:
      return 'Message Us';
    case ChannelCode.CHAT:
      return 'Chat';
    default:
      return channelCode || '';
  }
};

export const createConsolidatedContact = (
  realTimeHMDContact: RealTimeHMDContactForReview,
  cscEntityPrefix: string,
  userID: string,
  contactID: string
): ConsolidatedContact => {
  const communicationDateMoment = moment(
    realTimeHMDContact.communicationDate
  ).utc();

  // Moment does not have built-in support for Amazon/NA Calendar.
  // Adding 1 day is mimicing Amazon Week in moment api.
  // This is also aligned with how getConsolidatedContact derives week number from a given UTC date.
  // Ref: http://tiny.amazon.com/hc02nrri/codeamazpackAPETblob199asrc
  const weekEncoded = communicationDateMoment.add(1, 'day').format('GGGG-WW');
  const { year, week } = getWeekAndYear(weekEncoded);

  return {
    contactID: contactID,
    userID: `${cscEntityPrefix}:${userID}`,
    marketplaceID: '',
    marketplaceDomainName: '', // This might need to be filled from elsewhere if needed
    status: ContactStatusOptionsObject.NOTREVIEWED,
    calYear: year,
    calWeek: week,
    contactDate: realTimeHMDContact.communicationDate || '',
    sic: realTimeHMDContact.issueCode?.split('>')[0] || '',
    channel: mapChannelCode(realTimeHMDContact.channelCode || ''),
    recommended: 0,
    recent: 1,
    saved: 1,
    saveOrigin: 2,
    contactStatus: ContactStatusOptionsObject.NOTREVIEWED,
    formReviews: undefined,
  };
};
export function mergeContactStatusWithHmdDetails(
  hmdDetails: HMDDetails,
  contactStatus: ContactStatus
): HMDDetails {
  if (!hmdDetails || !contactStatus) {
    console.error('HMD Details or Contact Status is undefined');
  }

  const contactStatusMap = new Map<string, string>();
  contactStatus.contactStatuses.forEach(item => {
    contactStatusMap.set(item.commId, item.contactStatus);
  });

  const mergeStatus = (responses: any[]) =>
    responses.map(detail => ({
      ...detail,
      contactStatus: contactStatusMap.get(detail.contactID) || '',
    }));

  const mergedDetails: HMDDetails = {
    ...hmdDetails,
    yesResponses: mergeStatus(hmdDetails.yesResponses || []),
    noResponses: mergeStatus(hmdDetails.noResponses || []),
    repeatResponses: mergeStatus(hmdDetails.repeatResponses || []),
  };

  return mergedDetails;
}

export const createUserInput = (
  user: ExtendedUser | User,
  cscEntityPrefix: string
): UserInput => ({
  userAlias: user.alias,
  userId: `${cscEntityPrefix}:${user.userID}`,
});
